// extracted by mini-css-extract-plugin
export default {"container":"S9-z","productName":"T9-z","price":"U9-z","dimensions":"V9-z"};